// Actions
export const BUDGET_LINE_FETCH  = '[BudgetLine] Fetch'

// Mutations
export const BUDGET_LINE_META   = '[BudgetLine] meta'
export const BUDGET_LINE_OBTAIN = '[BudgetLine] obtain'
export const BUDGET_LINE_CLEAR  = '[BudgetLine] clear'
export const BUDGET_LINE_SET_LOADING = '[BudgetLine] set loading'
